/**
 * Fetch remediation documents (arbitium_remediations).
 */
import { fetchRing } from '../core';
import type { RemediationItem } from './create_remediation';

const RING_REMEDIATIONS = 'arbitium_remediations';

/**
 * Fetches all remediation documents from the backend ring.
 */
export async function getRemediations(): Promise<RemediationItem[]> {
  const res = await fetchRing<RemediationItem>(RING_REMEDIATIONS, { all: true });
  return Array.isArray(res.items) ? res.items : [];
}

